import {
	VelocityClient,
	VelocityEnv,
	PublicKey,
	SpotBalanceType,
	UserAccount,
	ZERO,
} from '@velocity-exchange/sdk';
import {
	matchEnum,
	abbreviateAddress,
	getUserKey,
} from '@velocity-exchange/common';
import { AccountData } from 'src/stores/useDriftAccountsStore';
import {
	LP_SUBACCOUNT_NAME,
	NEW_LP_SUBACCOUNT_NAME,
} from 'src/constants/constants';

export const getDelegateAccountLabel = (account: AccountData): string => {
	if (!account) return '';
	return `${abbreviateAddress(account.authority)} (${account.userId})`;
};

export const getSubAccountStorageKey = (
	authority: PublicKey,
	env: VelocityEnv
) => {
	return authority ? `${authority?.toString()}_subacct_${env}` : '';
};

export const accountNameIsLp = (accountName: string) =>
	[LP_SUBACCOUNT_NAME, NEW_LP_SUBACCOUNT_NAME].includes(accountName);

export const updateCurrentSubAccount = (
	newValue: number,
	authority: PublicKey,
	driftClient: VelocityClient,
	setAccountStore: any
) => {
	const userKey = getUserKey(newValue, authority);

	setAccountStore((s: any) => {
		s.currentUserKey = userKey;
	});

	driftClient.switchActiveUser(newValue, authority);
};

export const userHasNonUsdcBorrows = (userAccount: UserAccount) => {
	if (!userAccount || !userAccount?.spotPositions) {
		return false;
	}

	const openNonUsdcBorrows = userAccount?.spotPositions?.filter(
		(spotPosition) => {
			return (
				spotPosition.marketIndex !== 0 &&
				!spotPosition.scaledBalance.eq(ZERO) &&
				matchEnum(spotPosition.balanceType, SpotBalanceType.BORROW)
			);
		}
	);

	return openNonUsdcBorrows && openNonUsdcBorrows.length > 0;
};
